import React from 'react'
import styled, { css } from 'styled-components'
import * as SVG from './SVG'
import * as Illustrate from './illustrate'

const IconWrapper = styled.div`
  > svg {
    width: 100%;
    height: 100%;
    display: block;
    path {
      transition: all 0.2s ease-in 0s;
    }
  }

  ${props =>
    props.mobileHidden &&
    css`
      display: none;

      @media (min-width: 768px) {
        display: block;
      }
    `}
`;

const Icons = ({
  icon,
  color = '#fff',
  style,
  handleClick,
  mobileHidden,
  ...allTheRest
}) => {
  const SVGIcon = SVG[icon];
  // const SVGIconIllustrate = Illustrate[icon];

  return (
    <IconWrapper
      style={style}
      onClick={handleClick}
      mobileHidden={mobileHidden}
    >
      {SVGIcon && <SVGIcon color={color} {...allTheRest} />}
      {/* {SVGIconIllustrate && <SVGIconIllustrate color={color} {...allTheRest} />} */}
    </IconWrapper>
  )
}

export { Icons };
